var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteicon = function SvgDeleteicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.417 1h-3.209l-.916-1H4.708l-.916 1H.583v2h12.834V1ZM1.5 16c0 .53.193 1.04.537 1.414.344.375.81.586 1.296.586h7.334c.486 0 .952-.21 1.296-.586.344-.375.537-.884.537-1.414V4h-11v12Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgDeleteicon;